import { Observable } from "rxjs";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { URL_LOGIN } from "@ibe.config";

@Injectable()
export class CookieInterceptor implements HttpInterceptor {
  constructor(private cookieService: CookieService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {

		// Filter url and payload for cookie login
    if (request.url.includes(URL_LOGIN) && (request.body && JSON.stringify(request.body) === '{}')) {
      const clonedRequest = request.clone({
        withCredentials: true,
      });

      return next.handle(clonedRequest);
    }

    return next.handle(request);
  }
}
